import { useEffect, useState, useRef } from 'react';
import config from '../../common/config';
import useSvgPlay from '../../../hooks/useSvgPlay';
import './styles/Digest7.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const slide: any = config.slides[seq];
  const logoSRef: any = useRef();

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 10);
    } else {
      setDelayPlay(false);
    }
  }, [play]);

  useSvgPlay(slide.svgs[0], delayPlay, logoSRef);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div ref={logoSRef} className="logo-s"></div>

      <div className={`digest ${delayPlay ? 'ani-fade-out' : ''}`}>
        <div className="text-block">
          <div className="text-on-logo">Service</div>

          <div className={`titles`}>
            <div className="title title-primary">场景化设计</div>
          </div>

          <div className={`description`}>
            随着Gen-Z逐步成为一线岗位的主力军&amp;人们在线体验要求的提高，Happy
            working已经在z时代掀起新浪潮。 同样场景化设计也可以让我们的办公更有节奏，提高工作效率。
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
